import { ApiHelper } from '../apiHelper';
import { UserDAO } from './userDAO';
import { RoleDAO } from './roleDAO';
import { PermissionDAO } from './permissionDAO';
import { WaterBodyDAO } from './waterBodyDAO';
import { UploadDAO } from './uploadDAO';
import { CaptainDAO } from './captainDAO';
import { BookingDAO } from './bookingDAO';
import { DiscountDAO } from './discountDAO';
import { BoatOwnerDAO } from './boatOwnerDAO';
import { VesselDAO } from './vesselDAO';
import { VesselCaptainMapDAO } from './vesselCaptainMapDAO';
import { ServiceRecordDAO } from './serviceRecordDAO';
import { VesselImageDAO } from './vesselImageDAO';
import { CharterDAO } from './charterDAO';
import { PayoutDAO } from './payoutDAO';
import { CrewMemberDAO } from './crewMemberDAO';
import { PaymentDAO } from './paymentDAO';
import { VesselRateDAO } from './vesselRateDAO';
import { MooringLocationDAO } from './mooringLocationDAO';
import { ReportDAO } from './reportDAO';
import { CustomerDAO } from './customerDAO';
import { PaystubDAO } from './paystubDAO';
import { CaptainManageDetailsDAO } from './captainManageDetailsDAO';
import { SubPayoutDAO } from './subPayoutDAO';
import { ProductOfferingDAO } from './productOfferingDAO';
import { CalendarPreferencesDAO } from './calendarPreferencesDAO';
import { CharterVesselAvailabilityDAO } from './charterVesselAvailabilityDAO';
import { VesselAvailabilityPreferencesDAO } from './vesselAvailabilityPreferencesDAO';
import { AffiliateDAO } from './affiliateDAO';
import { LoggingDAO } from './loggingDAO';
import { CharterAlternateTimeRequestsDAO } from './charterAlternateTimeRequestsDAO';
import { NotificationDAO } from './notificationDAO';
import { DeviceInfoService } from '../device-info/device-info.service';
import { CaptainGigDAO } from './captainGigDAO';
import { HubspotContactUpdateDAO } from './hubspotContactUpdateDAO';
import { CharterNoteDAO } from './charterNoteDAO';
import { VesselAvailabilityDAO } from './VesselAvailabilityDAO';
import { VesselSplitRateDAO } from './vesselSplitRateDAO';
import { CharterPaymentDAO } from './charterPaymentDAO';
import { StripePaymentDAO } from './stripePaymentDAO';
import { AbandonedBuyflowDAO } from './abandonedBuyflowDAO';
import { PostsDAO } from './postsDAO';
import { OfferDAO } from './offerDAO';
import { MarketDAO } from './marketDAO';
import { CustomerReviewDAO } from './customerReviewDAO';
import { AddOnDAO } from './addOnDAO';
import { CometChatDAO } from './cometChatDAO';

export function masterUserDaoFactory(apiHelper: ApiHelper) {
  return new UserDAO(apiHelper);
}

export function masterRoleDaoFactory(apiHelper: ApiHelper) {
  return new RoleDAO(apiHelper);
}

export function masterPermissionDaoFactory(apiHelper: ApiHelper) {
  return new PermissionDAO(apiHelper);
}

export function masterWaterBodyDAOFactory(apiHelper: ApiHelper) {
  return new WaterBodyDAO(apiHelper);
}

export function masterUploadDAOFactory(apiHelper: ApiHelper) {
  return new UploadDAO(apiHelper);
}

export function masterCaptainDAOFactory(apiHelper: ApiHelper) {
  return new CaptainDAO(apiHelper);
}

export function masterBookingDAOFactory(apiHelper: ApiHelper) {
  return new BookingDAO(apiHelper);
}

export function masterDiscountDAOFactory(apiHelper: ApiHelper) {
  return new DiscountDAO(apiHelper);
}

export function masterVesselDAOFactory(apiHelper: ApiHelper) {
  return new VesselDAO(apiHelper);
}

export function masterVesselCaptainMapDAOFactory(apiHelper: ApiHelper) {
  return new VesselCaptainMapDAO(apiHelper);
}

export function masterServiceRecordDAOFactory(apiHelper: ApiHelper) {
  return new ServiceRecordDAO(apiHelper);
}

export function masterVesselImageDAOFactory(apiHelper: ApiHelper) {
  return new VesselImageDAO(apiHelper);
}

export function masterAddOnDAOFactory(apiHelper: ApiHelper) {
  return new AddOnDAO(apiHelper);
}

export function masterCharterDAOFactory(apiHelper: ApiHelper) {
  return new CharterDAO(apiHelper);
}

export function masterPayoutDAOFactory(apiHelper: ApiHelper) {
  return new PayoutDAO(apiHelper);
}

export function masterSubPayoutDAOFactory(apiHelper: ApiHelper) {
  return new SubPayoutDAO(apiHelper);
}

export function masterPaystubDAOFactory(apiHelper: ApiHelper) {
  return new PaystubDAO(apiHelper);
}

export function masterProductOfferingDAOFactory(apiHelper: ApiHelper) {
  return new ProductOfferingDAO(apiHelper);
}

export function masterBoatOwnerDAOFactory(apiHelper: ApiHelper) {
  return new BoatOwnerDAO(apiHelper);
}

export function masterCrewMemberDAOFactory(apiHelper: ApiHelper) {
  return new CrewMemberDAO(apiHelper);
}

export function masterPaymentDAOFactory(apiHelper: ApiHelper) {
  return new PaymentDAO(apiHelper);
}

export function masterVesselRateDAOFactory(apiHelper: ApiHelper) {
  return new VesselRateDAO(apiHelper);
}
export function masterMooringLocationDAOFactory(apiHelper: ApiHelper) {
  return new MooringLocationDAO(apiHelper);
}

export function masterReportDAOFactory(apiHelper: ApiHelper) {
  return new ReportDAO(apiHelper);
}

export function masterCustomerDAOFactory(apiHelper: ApiHelper) {
  return new CustomerDAO(apiHelper);
}

export function masterCustomerReviewDAOFactory(apiHelper: ApiHelper) {
  return new CustomerReviewDAO(apiHelper);
}

export function masterCaptainManageDetailsDAOFactory(apiHelper: ApiHelper) {
  return new CaptainManageDetailsDAO(apiHelper);
}

export function masterCalendarPreferencesDAOFactory(apiHelper: ApiHelper) {
  return new CalendarPreferencesDAO(apiHelper);
}

export function masterCharterVesselAvailabilityDAOFactory(
  apiHelper: ApiHelper,
) {
  return new CharterVesselAvailabilityDAO(apiHelper);
}

export function masterCharterPaymentDAOFactory(apiHelper: ApiHelper) {
  return new CharterPaymentDAO(apiHelper);
}

export function masterStripePaymentDAOFactory(apiHelper: ApiHelper) {
  return new StripePaymentDAO(apiHelper);
}

export function masterVesselAvailabilityPreferencesDAOFactory(
  apiHelper: ApiHelper,
) {
  return new VesselAvailabilityPreferencesDAO(apiHelper);
}

export function masterAffiliateDAOFactory(apiHelper: ApiHelper) {
  return new AffiliateDAO(apiHelper);
}

export function masterAbandonedBuyflowDAOFactory(apiHelper: ApiHelper) {
  return new AbandonedBuyflowDAO(apiHelper);
}

export function masterLoggingDAOFactory(
  apiHelper: ApiHelper,
  deviceInfoService: DeviceInfoService,
) {
  return new LoggingDAO(apiHelper, deviceInfoService);
}

export function masterCharterAlternateTimeRequestsDAOFactory(
  apiHelper: ApiHelper,
) {
  return new CharterAlternateTimeRequestsDAO(apiHelper);
}

export function masterOfferDAOFactory(apiHelper: ApiHelper) {
  return new OfferDAO(apiHelper);
}

export function masterMarketDAOFactory(apiHelper: ApiHelper) {
  return new MarketDAO(apiHelper);
}

export function masterCaptainGigDAOFactory(apiHelper: ApiHelper) {
  return new CaptainGigDAO(apiHelper);
}

export function masterHubspotContactUpdateDAOFactory(apiHelper: ApiHelper) {
  return new HubspotContactUpdateDAO(apiHelper);
}

export function masterNotificationDAOFactory(apiHelper: ApiHelper) {
  return new NotificationDAO(apiHelper);
}

export function masterCharterNoteDAOFactory(apiHelper: ApiHelper) {
  return new CharterNoteDAO(apiHelper);
}

export function masterVesselAvailabilityDAOFactory(apiHelper: ApiHelper) {
  return new VesselAvailabilityDAO(apiHelper);
}

export function vesselSplitRateDAOFactory(apiHelper: ApiHelper) {
  return new VesselSplitRateDAO(apiHelper);
}

export function postDAOFactory(apiHelper: ApiHelper) {
  return new PostsDAO(apiHelper);
}

export function masterCometChatDAOFactory(apiHelper: ApiHelper) {
  return new CometChatDAO(apiHelper);
}

export function provideMasterUserDAO() {
  return {
    provide: UserDAO,
    useFactory: masterUserDaoFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterRoleDAO() {
  return {
    provide: RoleDAO,
    useFactory: masterRoleDaoFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterPermissionDAO() {
  return {
    provide: PermissionDAO,
    useFactory: masterPermissionDaoFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterWaterBodyDAO() {
  return {
    provide: WaterBodyDAO,
    useFactory: masterWaterBodyDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterUploadDAO() {
  return {
    provide: UploadDAO,
    useFactory: masterUploadDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCaptainDAO() {
  return {
    provide: CaptainDAO,
    useFactory: masterCaptainDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterBookingDAO() {
  return {
    provide: BookingDAO,
    useFactory: masterBookingDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterDiscountDAO() {
  return {
    provide: DiscountDAO,
    useFactory: masterDiscountDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterVesselDAO() {
  return {
    provide: VesselDAO,
    useFactory: masterVesselDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterVesselCaptainMapDAO() {
  return {
    provide: VesselCaptainMapDAO,
    useFactory: masterVesselCaptainMapDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterServiceRecordDAO() {
  return {
    provide: ServiceRecordDAO,
    useFactory: masterServiceRecordDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterVesselImageDAO() {
  return {
    provide: VesselImageDAO,
    useFactory: masterVesselImageDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterAddOnDAO() {
  return {
    provide: AddOnDAO,
    useFactory: masterAddOnDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCharterDAO() {
  return {
    provide: CharterDAO,
    useFactory: masterCharterDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterPayoutDAO() {
  return {
    provide: PayoutDAO,
    useFactory: masterPayoutDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterSubPayoutDAO() {
  return {
    provide: SubPayoutDAO,
    useFactory: masterSubPayoutDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterPaystubDAO() {
  return {
    provide: PaystubDAO,
    useFactory: masterPaystubDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterProductOfferingDAO() {
  return {
    provide: ProductOfferingDAO,
    useFactory: masterProductOfferingDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterBoatOwnerDAO() {
  return {
    provide: BoatOwnerDAO,
    useFactory: masterBoatOwnerDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCrewMemberDAO() {
  return {
    provide: CrewMemberDAO,
    useFactory: masterCrewMemberDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterPaymentDAO() {
  return {
    provide: PaymentDAO,
    useFactory: masterPaymentDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterVesselRateDAO() {
  return {
    provide: VesselRateDAO,
    useFactory: masterVesselRateDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterMooringLocationDAO() {
  return {
    provide: MooringLocationDAO,
    useFactory: masterMooringLocationDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterReportDAO() {
  return {
    provide: ReportDAO,
    useFactory: masterReportDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCustomerDAO() {
  return {
    provide: CustomerDAO,
    useFactory: masterCustomerDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCustomerReviewDAO() {
  return {
    provide: CustomerReviewDAO,
    useFactory: masterCustomerReviewDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCaptainManageDetailsDAO() {
  return {
    provide: CaptainManageDetailsDAO,
    useFactory: masterCaptainManageDetailsDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCalendarPreferencesDAO() {
  return {
    provide: CalendarPreferencesDAO,
    useFactory: masterCalendarPreferencesDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCharterVesselAvailabilityDAO() {
  return {
    provide: CharterVesselAvailabilityDAO,
    useFactory: masterCharterVesselAvailabilityDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCharterPaymentDAO() {
  return {
    provide: CharterPaymentDAO,
    useFactory: masterCharterPaymentDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterStripePaymentDAO() {
  return {
    provide: StripePaymentDAO,
    useFactory: masterStripePaymentDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterVesselAvailabilityPreferencesDAO() {
  return {
    provide: VesselAvailabilityPreferencesDAO,
    useFactory: masterVesselAvailabilityPreferencesDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterAffiliateDAO() {
  return {
    provide: AffiliateDAO,
    useFactory: masterAffiliateDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterAbandonedBuyflowDAO() {
  return {
    provide: AbandonedBuyflowDAO,
    useFactory: masterAbandonedBuyflowDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterLoggingDAO() {
  return {
    provide: LoggingDAO,
    useFactory: masterLoggingDAOFactory,
    deps: [ApiHelper, DeviceInfoService],
  };
}

export function provideMasterNotificationDAO() {
  return {
    provide: NotificationDAO,
    useFactory: masterNotificationDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCharterAlternateTimeRequestsDAO() {
  return {
    provide: CharterAlternateTimeRequestsDAO,
    useFactory: masterCharterAlternateTimeRequestsDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterOfferDAO() {
  return {
    provide: OfferDAO,
    useFactory: masterOfferDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterMarketDAO() {
  return {
    provide: MarketDAO,
    useFactory: masterMarketDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCaptainGigDAO() {
  return {
    provide: CaptainGigDAO,
    useFactory: masterCaptainGigDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideHubspotContactUpdateDAO() {
  return {
    provide: HubspotContactUpdateDAO,
    useFactory: masterHubspotContactUpdateDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideCharterNoteDAO() {
  return {
    provide: CharterNoteDAO,
    useFactory: masterCharterNoteDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterVesselAvailabilityDAO() {
  return {
    provide: VesselAvailabilityDAO,
    useFactory: masterVesselAvailabilityDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideVesselSplitRateDAO() {
  return {
    provide: VesselSplitRateDAO,
    useFactory: vesselSplitRateDAOFactory,
    deps: [ApiHelper],
  };
}

export function providePostsDAO() {
  return {
    provide: PostsDAO,
    useFactory: postDAOFactory,
    deps: [ApiHelper],
  };
}

export function provideMasterCometChatDAO() {
  return {
    provide: CometChatDAO,
    useFactory: masterCometChatDAOFactory,
    deps: [ApiHelper],
  };
}
